<template>
    <div>
        <van-tabbar route class="bottom_tabbar">
            <van-tabbar-item replace to="/M" icon="home-o">首页</van-tabbar-item>
            <van-tabbar-item replace to="/M/service" icon="like-o">服务</van-tabbar-item>
            <van-tabbar-item replace to="/M/userSpace/my" icon="user-circle-o">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>